import { klaviyoSubscribe } from '@theme/utilities';

if (!customElements.get('klaviyo-form')) {
  class KlaviyoForm extends HTMLElement {

    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.successMessageEl = this.querySelector('[data-success]');
      this.source = this.getAttribute('form-source');
    }

    onSubmit(event) {
      event.preventDefault();
      const email = event.target.elements.email.value;
      const klaviyoListId = event.target.dataset.klaviyoListId;
      klaviyoSubscribe(klaviyoListId, email, this.source);
      this.successMessageEl.classList.remove('hidden');
      this.form.reset();
    }
  }
  customElements.define('klaviyo-form', KlaviyoForm);
}

const buttons = document.querySelectorAll('[data-animated-arrow]');

buttons.forEach((button) => {
  const arrow = button.querySelector('.arrow-group');
  if (!arrow) return;

  let animation = null;

  button.addEventListener('mouseenter', () => {
    if (animation) animation.cancel();
    animation = arrow.animate(
      [
        { transform: 'translateX(0px)', offset: 0 },
        { transform: 'translateX(30px)', offset: 0.33 },
        { transform: 'translateX(-30px)', offset: 0.34 },
        { transform: 'translateX(3px)', offset: 0.7 },
        { transform: 'translateX(-2px)', offset: 0.85 },
        { transform: 'translateX(0px)', offset: 1 },
      ],
      { duration: 300, easing: 'ease-in-out', fill: 'forwards' }
    );
  });

  button.addEventListener('mouseleave', () => {
    if (animation) {
      animation.cancel();
      animation = null;
    }
  });
});
